import { FunctionComponent } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { Autocomplete } from '../../../../atoms/Form';
import { Tag } from '../../../../atoms/Tag';
import { SafeFormattedMessageWithoutSpread } from '../../../../formatters';
import { NumericRubric } from '../../Datatable.types';
import { DatatableFiltersModel } from '../DatatableFiltersModel';
import messages from '../messages';

import { useFilterNumeric } from './FiltersNumeric.hooks';

const FiltersNumeric: FunctionComponent<{
  filter: NumericRubric;
  onChange: (selectedFilter: NumericRubric) => void;
  dataTestId?: string;
}> = ({ filter, onChange, dataTestId }) => {
  const {
    filtersNumericValue,
    buildFiltersNumericOptions,
    handleFilterNumericSelected,
  } = useFilterNumeric({ filter, onChange });

  const { control } = useFormContext();

  return (
    <DatatableFiltersModel
      title={filter.label}
      tag={
        <Tag
          primary
          withoutMargin
          dataTestId={`${dataTestId}_filterNumeric_tag_${filter.name}`}
        >
          {filtersNumericValue.length ===
          Object.values(buildFiltersNumericOptions(filter.facets)).length ? (
            <SafeFormattedMessageWithoutSpread message={messages.allSelected} />
          ) : (
            filtersNumericValue.length
          )}
        </Tag>
      }
      filterContent={
        <Controller
          name={`filterNumeric_${filter.name}`}
          control={control}
          render={({ field }) => (
            <Autocomplete
              closeMenuOnSelect={false}
              isLoading={false}
              isMulti
              ref={field.ref}
              value={field.value}
              name={field.name}
              onChange={(newValue) => {
                field.onChange(newValue);
                handleFilterNumericSelected(newValue as any);
              }}
              options={buildFiltersNumericOptions(filter.facets)}
              placeholder={messages.selectFilters}
              dataTestId={`${dataTestId}_filterNumeric_${filter.name}`}
            />
          )}
        />
      }
    />
  );
};

FiltersNumeric.displayName = 'FiltersNumeric';
export default FiltersNumeric;
